module.exports = __webpack_public_path__ + "static/media/gruppo_compatto.9fb98e34.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/gruppo_compatto.mp3
// module id = 188
// module chunks = 0